class AddToBag extends HTMLElement {
  constructor() {
    super();
    this.timer = undefined; // Timer to remove the modal after 3 seconds
  }

  /**
   * Reveals the modal and overlay
   */
  openModal() {
    this.querySelector('.CartATB__modal').classList.add('enabled');
    this.querySelector('.CartATB__overlay').classList.add('CartATB__overlay--show');
    // Delay to allow CSS transition
    setTimeout(() => this.querySelector('.CartATB__modal').classList.add('revealed'), 10);
  }

  /**
   * put off any action by certain milliseconds
   * @param {number} ms - time in milliseconds
   * @returns {Promise<void>} - a Promise
   */
  #delay(ms, callback) {
    if (this.timer) clearTimeout(this.timer);

    return new Promise((resolve) => {
      this.timer = setTimeout(() => {
        callback();
        return resolve;
      }, ms);
    });
  }

  /**
   * Called when the element is added to the DOM
   */
  connectedCallback() {
    this.querySelector('.CartATB__close').addEventListener('click', this.closeModal.bind(this));
  }

  /**
   * Closes the modal and overlay
   */
  closeModal(e) {
    // If the close button is clicked, close immediately; otherwise, wait 2 seconds
    const isCloseBtn = e?.target.classList.contains('CartATB__close') ? 0 : 2000;

    this.#delay(isCloseBtn, () => {
      this.querySelector('.CartATB__modal').classList.remove('revealed');
      this.querySelector('.CartATB__overlay').classList.remove('CartATB__overlay--show');
      // Delay to allow CSS transition
      setTimeout(() => this.querySelector('.CartATB__modal').classList.remove('enabled'), 10);
    });
  }
}

export default AddToBag;
